import { createAction } from "@reduxjs/toolkit"
import { GET, POST } from "lib/core/api"
import { createAsyncAction } from "lib/core/redux.utils"
import { noteTypeMapping } from "./pupils.api"

export { noteTypeMapping }

export const getPupil = createAsyncAction(
  "GET_PUPIL",
  (id, schoolId) => {
    return GET(`/pupils/${id}/`, { query: { school_id: schoolId } })
  },
  true,
)

export const createOrUpdatePupilObservation = createAsyncAction(
  "UPDATE_PUPIL_OBSERVATION",
  (pupilObservation) =>
    POST("/social_emotional_observation/", pupilObservation),
)

export const addPupilScoreNote = createAction(
  "pupils/addPupilScoreNote",
  (testType, note) => ({
    payload: { testType, note },
  }),
)

export const updatePupilScoreNote = createAction(
  "pupils/updatePupilScoreNote",
  (testType, note) => ({
    payload: { testType, note },
  }),
)

export const deletePupilScoreNote = createAction(
  "pupils/deletePupilScoreNote",
  (testType, note) => ({
    payload: { testType, note },
  }),
)

export const incrementRemovedPrintSectionCount = createAction(
  "INCREMENT_REMOVED_PRINT_SECTION_COUNT",
)

export const decrementRemovedPrintSectionCount = createAction(
  "DECREMENT_REMOVED_PRINT_SECTION_COUNT",
)

export const resetRemovedPrintSectionCount = createAction(
  "RESET_REMOVED_PRINT_SECTION_COUNT",
)

export const getPupilOutflowAdvice = createAsyncAction(
  "GET_PUPIL_OUTFLOW_ADVICE",
  (pupilId) => GET(`/pupil-outflow-advice/${pupilId}`),
)

export const updatePupilOutflowAdvice = createAsyncAction(
  "UPDATE_PUPIL_OUTFLOW_ADVICE",
  (pupilId, outflowAdvice) =>
    POST("/pupil-outflow-advice/", { pupilId, outflowAdvice }),
)
